import { forEach, keys } from 'lodash';
import { COUNTRY_LIST } from '../constants/AppConstants';
import validateValue from './validateValue.util';

/**
 * Mandatory fields with error message string if falsy
 */
export const mandatoryFields = {
  streetAddress1: 'Address',
  city: 'City',
  state: 'State',
  zipCode: 'Zip code',
  country: 'Country',
  phone: 'Phone',
};

/**
 * Number fields with error message string to show if NUMBER_VALIDATION_REGEX does not match
 */
export const numberFields = {};
/**
 * String fields with error message string to show if STRING_VALIDATION_REGEX does not match
 */
export const stringFields = {
  city: 'City',
};

/**
 * Validates each input received and returns the error message accordingly
 * @param {Array} addressInputValues - Array of objects containing address input field and value to be validated
 */

/**
  * @param {string} abbreviation - abbreviation of selected country
  */
const validateAddressInput = (addressInputValues, countryId) => {
  const errorMsgs = {};

  const { abbreviation } = COUNTRY_LIST.find((country) => country.countryId === (countryId || addressInputValues.country)) || { abbreviation: '' };

  forEach(keys(addressInputValues),
    (field) => {
      const value = field === 'phone' ? addressInputValues[field].number : addressInputValues[field];
      const errorMsg = validateValue({ mandatoryFields, numberFields, stringFields }, field, value, abbreviation);
      errorMsgs[field] = errorMsg;
      if (errorMsgs[field] !== '') {
        errorMsgs.hasValidationErrors = true;
      }
    });
  return errorMsgs;
};

export default validateAddressInput;
